import { QueryClient } from 'react-query';
import { enqueueSnackbar } from 'notistack';
import { TOAST_CONFIG } from '../hooks/use-toast.hook';
import { AxiosError } from 'axios';
import { addError } from './datadog';
import { getAxiosErrorMessage } from './services';
import { safeRefreshTokenUser } from './services/auth.service';

export enum AppDataQueryKey {
  PartnerBasicInfo = 'app-data-partner-basic-info',
  PartnerUserPermissions = 'app-data-partner-user-permissions',
}

export enum QueryKey {
  PartnerBranding = 'partner-branding',
  PartnerDataset = 'partner-dataset',
  PartnerProfile = 'partner-profile',
  PartnerIdent = 'partner-ident',
  PartnerList = 'partner-list',
  PartnerView = 'partner-view',
  PartnerUserView = 'partner-user-view',
  PartnerMembers = 'partner-members',
  OrgsDataset = 'orgs-dataset',
  OrgView = 'org-view',
  ConversionIssueTypes = 'conversion-issue-types',
  RootUsersDataset = 'root-users-dataset',
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 4000, // how long before cached data is marked as stale and automatically refreshed?
      cacheTime: 0, // how long before cached data is removed from cache via gc?
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: 2,
      onError: (error: AxiosError) => {
        addError(error);

        const { status } = error || {};

        if (status === 401) {
          safeRefreshTokenUser();
          return;
        }

        const { message } = getAxiosErrorMessage(error, {
          429: 'Too many requests. Please wait a minute and try again.',
        });
        enqueueSnackbar(message, { ...TOAST_CONFIG, variant: 'error' });
      },
    },
  },
});
